import $ from 'jquery';

$(document).ready(function() {
    $('#coupon_mirror').on('input', function() {
        $('#coupon_code').val($(this).val());
    });

    $('#apply_coupon_mirror').click(function() {
        $('button[name="apply_coupon"]').click();
    });

    $(document.body).on('updated_checkout', function() {
        var coupon_error = $('.woocommerce-form-coupon-toggle ~ .woocommerce-error > li').text();

        if(coupon_error != '') {
            if($('.coupon__note').length) {
                $('.coupon__form .coupon__note').text(coupon_error);
            } else {
                $('.coupon__form').append('<span class="coupon__note">' + coupon_error + '</span>');
            }
        } else {
            $('.coupon__note').remove();
        }
    });
});